/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * How a Novelist publisher delivers, set per publisher by a moderator. Not an
 * ``ImportChannel``: that records how one run entered, and one delivery method yields runs of
 * several channels.
 */
export type NovelistDeliveryMethod = typeof NovelistDeliveryMethod[keyof typeof NovelistDeliveryMethod];


export const NovelistDeliveryMethod = {
  ftp: 'ftp',
} as const;
